const home = {
  banner: {
    title: "Safie Developers",
    des: "セーフィーのクラウド録画サービスとのAPI連携を実現。<br/>映像データを活用したWebサービスやアプリケーションの開発を可能にします。",
    btn: {
      text: "新規ユーザー登録",
      router: "/signup",
    },
    guide: "スクロール",
  },
  guide: {
    title: "スタートガイド",
    subTitle:
      "Safie Developersのご利用手順や設計にあたってのガイドラインです。ご参照ください。",
    img: require("./image/developers-image.png"),
    methodBtn: {
      text: "当サイトの使い方",
      router: "/tutorial/developers",
    },
    guideBtn: {
      text: "設計ガイドライン",
      router: "/guidelines",
    },
  },
  case: {
    title: "活用事例",
    subTitle:
      "Safie Developersを利用してどんなソリューションを開発できるのか、実際の事例をご紹介します。",
    btn: {
      text: "すべての活用事例を見る",
      router: "/casestudy",
    },
  },
  qa: {
    title: "よくあるご質問（FAQ）",
    subTitle: "よくお寄せいただくご質問とその回答をまとめています。",
    btn: {
      text: "すべてのFAQを見る",
      router: "/faq",
    },
  },
  note: {
    title: "リリースノート",
    btn: {
      text: "リリースノート一覧",
      router: "/releasenotes",
    },
  },
};

export default home;
